












































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {GithubOrganization} from '@/model/resource/GithubOrganization'
import {GithubRepository} from '@/model/resource/GithubRepository'

@Component({})
export default class CDWheelCenter extends Vue {
  @Prop({type: Number, default: null})
  selectedOrganizationId!: number | null

  @Prop({type: GithubOrganization, default: null})
  selectedOrganization!: GithubOrganization | null

  @Prop({type: GithubRepository, default: null})
  selectedRepository!: GithubRepository | null

  @Prop({type: Date, default: null})
  lastUpdateAt!: Date | null

  @Prop({type: Boolean, default: false})
  canPrev!: boolean

  @Prop({type: Boolean, default: false})
  canNext!: boolean

  get organizationDotStyle(): string {
    const hex = this.selectedOrganization?.colorHex
    return hex ? `background-color: #${hex}` : 'background-color: #CBD5E1'
  }

  handlePrevOrganization() {
    this.$emit('prev')
  }

  handleNextOrganization() {
    this.$emit('next')
  }

  clearRepositorySelection() {
    if (!this.selectedRepository) return
    this.$emit('selectRepository', null)
  }
}
